// TODO - Type 'any' needs to be fixed.
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Tooltip, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Slide from "@mui/material/Slide";
import TextField from "@mui/material/TextField";
import { DataGridPro } from "@mui/x-data-grid-pro";
import React, { useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { markAttendance } from "../../../components/scheduler/store/scheduler-slice";
import {colors} from "../../../config/colors";


const statusObj:any = {
	p: { titleKey: "flex-scheduler_present", color: "#017374" },
	a: { titleKey: "flex-scheduler_absent", color: "#b00020" },
	t: { titleKey: "flex-scheduler_tardy", color: "#01a299" },
	e: { titleKey: "flex-scheduler_excused-absence", color: "#7d5260" },
	x: { titleKey: "flex-scheduler_excused-tardiness", color: "#7d5260" },
};

const actionItems = [
	{ titleKey: "flex-scheduler_present", status: "p", color: "#017374" },
	{ titleKey: "flex-scheduler_absent", status: "a", color: "#b00020" },
	{ titleKey: "flex-scheduler_tardy", status: "t", color: "#01a299" },
	{ titleKey: "flex-scheduler_excused-absence", status: "e", color: "#7d5260" },
	{ titleKey: "flex-scheduler_excused-tardy", status: "x", color: "#7d5260" },
];

const Transition = React.forwardRef(function Transition(props:any, ref:any) {
	return <Slide direction='up' ref={ref} {...props} />;
});

const ActionDialog = ({ item }:any) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const [open, setOpen] = useState(false);
	const [comment, setComment] = useState("");

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setComment("");
		setOpen(false);
	};

	const actions = actionItems.filter((action) => action.status !== item.status);

	const handleChange = (e:any) => {
		const char = e.target.value;
		if (char !== "c")
			dispatch(
				markAttendance({
					workerId: item.id,
					status: char,
					shiftId: item.shiftId,
					comment: item.comment,
				})
			);
		else handleClickOpen();
	};

	const handleComment = () => {
		dispatch(
			markAttendance({
				workerId: item.id,
				status: item.status,
				shiftId: item.shiftId,
				comment: comment,
			})
		);
		handleClose();
	};

	return (
		<Box>
			<Select
				id='demo-simple-select'
				IconComponent={MoreVertIcon}
				displayEmpty
				value=''
				variant='filled'
				onChange={handleChange}
				sx={{ backgroundColor: "white" }}
			>
				{actions.map((action) => {
					return (
						<MenuItem value={action.status} key={action.status}>
							{t(action.titleKey)}
						</MenuItem>
					);
				})}
				<MenuItem value='c'>{t("flex-scheduler_leave-a-comment")}</MenuItem>
			</Select>
			<Dialog
				open={open}
				TransitionComponent={Transition}
				keepMounted
				onClose={handleClose}
				aria-describedby='alert-dialog-slide-description'
			>
				<DialogTitle>{t("flex-scheduler_add-comments")}</DialogTitle>
				<DialogContent>
					<DialogContentText id='alert-dialog-slide-description'>
						{t("flex-scheduler_add-comments-for", { name: item.workerName })}
					</DialogContentText>
					<TextField
						id='outlined-multiline-static'
						// label="Comments"
						multiline
						rows={4}
						fullWidth
						sx={{ marginTop: 2 }}
						defaultValue={item.comment ?? ""}
						onChange={(e) => setComment(e.target.value)}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} sx={{ color: colors.gray }}>
						{t("common_cancel")}
					</Button>
					<Button disabled={comment.length === 0} onClick={handleComment}>
						{t("flex-scheduler_done")}
					</Button>
				</DialogActions>
			</Dialog>
		</Box>
	);
};
function ShiftStatusTable({ rows }:any) {
	const { t } = useTranslation();
	const dataGridRef :any= useRef();
	// const temp = rows.map((row)=> {
	//     return {...row,comment:"test comment"}
	// })

	const columns:any = useMemo(() => [
		{
			field: "workerName",
			headerName: t("flex-scheduler_worker-name"),
			width: 150,
			renderHeader: () => (
				<span style={{ padding: "0px 0x", fontWeight: "bold" }}>
					{t("flex-scheduler_worker-name")}
				</span>
			),
		},
		{
			field: "status",
			headerName: t("flex-scheduler_status"),
			headerAlign: "center",
			width: 150,
			renderHeader: () => (
				<span style={{ padding: "0px 12px", fontWeight: "bold" }}>
					{t("flex-scheduler_status")}
				</span>
			),
			renderCell: (params:any) => {
				return (
					<Box
						sx={{
							backgroundColor: statusObj[params.row.status]?.color,
							padding: "2px",
						}}
						borderRadius={1}
						width={130}
					>
						<Tooltip title={statusObj[params.row.status]?.titleKey ? t(statusObj[params.row.status].titleKey) : ""}>
							<Typography align='center' color='white' variant='subtitle2'>
								{statusObj[params.row.status]?.titleKey ? t(statusObj[params.row.status].titleKey) : ""}
							</Typography>
						</Tooltip>
					</Box>
				);
			},
		},
		{
			field: "comment",
			headerName: t("flex-scheduler_comment"),
			headerAlign: "center",
			renderHeader: () => (
				<span style={{ padding: "0px 12px", fontWeight: "bold" }}>
					{t("flex-scheduler_comment")}
				</span>
			),
			minWidth: 150,
			flexGrow: 1,
			flex: 3,
			renderCell: (params:any) => (
				<Tooltip title={params?.row?.comment}>
					<span>{params?.row?.comment}</span>
				</Tooltip>
			),
		},
		{
			field: "action",
			headerName: t("common_actions"),
			width: 100,
			sortable: false,
			filterable: false,
			disableColumnMenu: true,
			headerAlign: "right",
			renderHeader: () => (
				<span style={{ padding: "0px 12px", fontWeight: "bold" }}>
					{t("common_actions")}
				</span>
			),
			renderCell: (params:any) => (
				<div
					style={{
						display: "flex",
						width: "100%",
						justifyContent: "flex-end",
						alignItems: "center",
					}}
				>
					<ActionDialog item={params.row} />
				</div>
			),
		},
	], [t]);

	return (
		<Box width={600}>
			<DataGridPro
				ref={dataGridRef}
				rows={rows}
				columns={columns}
				// height
				hideFooter
				disableColumnSelector
				disableDensitySelector
				disableSelectionOnClick
				getRowHeight={() => "auto"}
				sx={{
					position: "sticky",
					"&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
						py: "10px",
					},
				}}
			/>
		</Box>
	);
}

export default ShiftStatusTable;
